import React, { Component } from 'react';
import { withRouter } from 'react-router';

import { getContent } from "../../util/responseUtil";
import API_AUTHENTICATION from "../../api/apiAuthentication";

// const AssetLinks = () => {
//     const [fileContent, setFileContent] = useState('');
//
//     // useEffect(() => {
//         const fetchFileContent = async () => {
//             try {
//                 const response = await fetch('http://localhost:2000/.well-known/assetlinks.json');
//                 // const response = await fetch('https://sandbox-care.nexcloud.id/.well-known/assetlinks.json');
//                 // const response = await fetch(ROUTER_CONSTANT.ASSET_LINKS);
//                 console.log(ROUTER_CONSTANT.ASSET_LINKS)
//                 // console.log(API_AUTHENTICATION.ASSET_LINKS)
//                 // const response = await fetch(ROUTER_CONSTANT.ASSET_LINKS);
//                 const data = await response.text();
//                 setFileContent(data);
//             } catch (error) {
//                 console.error('Error fetching file content:', error);
//                 // this.setState({ errorMessage: getErrorMessage(err) });
//             }
//         };
//
//         fetchFileContent();
//     // }, []);
//
//     return <pre>{fileContent}</pre>;
// };

class AssetLinks extends Component {
    constructor(props) {
        super(props);
        this.state = {
            contents: ''
        }
    }

    componentDidMount() {
        this._isMounted = true;

        API_AUTHENTICATION.getAssetLinks()
            .then(res => {
                if (this._isMounted) {
                    this.setState({
                        contents: getContent(res).asset_links
                    })
                }
            })
    }

    componentWillUnmount() {
        this._isMounted = false;
    }

    render() {
        return (
            <>{this.state.contents}</>
        );
    }
}

// export default (AssetLinks);
export default withRouter(AssetLinks);